/**
 * Custom Lexical Nodes Index
 * Exports all custom nodes for AST-Lexical bridge compatibility
 */

// Paragraph Node
export {
  CustomParagraphNode,
  $createCustomParagraphNode,
  $isCustomParagraphNode,
  type SerializedCustomParagraphNode,
} from './CustomParagraphNode'

// Heading Node
export {
  CustomHeadingNode,
  $createCustomHeadingNode,
  $isCustomHeadingNode,
  type SerializedCustomHeadingNode,
  type HeadingLevel,
} from './CustomHeadingNode'

// List Node
export {
  CustomListNode,
  $createCustomListNode,
  $isCustomListNode,
  type SerializedCustomListNode,
} from './CustomListNode'

// List Item Node
export {
  CustomListItemNode,
  $createCustomListItemNode,
  $isCustomListItemNode,
  type SerializedCustomListItemNode,
} from './CustomListItemNode'

// Quote Node
export {
  CustomQuoteNode,
  $createCustomQuoteNode,
  $isCustomQuoteNode,
  type SerializedCustomQuoteNode,
} from './CustomQuoteNode'

// Divider Node
export {
  CustomDividerNode,
  $createCustomDividerNode,
  $isCustomDividerNode,
  type SerializedCustomDividerNode,
} from './CustomDividerNode'

// Image Node
export {
  CustomImageNode,
  $createCustomImageNode,
  $isCustomImageNode,
  type SerializedCustomImageNode,
} from './CustomImageNode'

// Live source embed
export {
  CustomEmbedNode,
  $createCustomEmbedNode,
  $isCustomEmbedNode,
  $selectionContainsEmbed,
  type SerializedCustomEmbedNode,
} from './CustomEmbedNode'

export {
  CustomInlineEmbedNode,
  $createCustomInlineEmbedNode,
  $isCustomInlineEmbedNode,
  type SerializedCustomInlineEmbedNode,
} from './CustomInlineEmbedNode'

// Encrypted Node
export {
  CustomEncryptedNode,
  $createCustomEncryptedNode,
  $isCustomEncryptedNode,
  type SerializedCustomEncryptedNode,
} from './CustomEncryptedNode'

// Link Node
export {
  CustomLinkNode,
  $createCustomLinkNode,
  $isCustomLinkNode,
  type SerializedCustomLinkNode,
} from './CustomLinkNode'

// All custom nodes array for LexicalComposer registration
import { LinkNode } from '@lexical/link'
import { ListItemNode, ListNode } from '@lexical/list'
import { HeadingNode, QuoteNode } from '@lexical/rich-text'
import { Klass, LexicalNode } from 'lexical'

import { CustomDividerNode } from './CustomDividerNode'
import { CustomEmbedNode } from './CustomEmbedNode'
import { CustomEncryptedNode } from './CustomEncryptedNode'
import { CustomHeadingNode } from './CustomHeadingNode'
import { CustomImageNode } from './CustomImageNode'
import { CustomInlineEmbedNode } from './CustomInlineEmbedNode'
import { CustomLinkNode } from './CustomLinkNode'
import { CustomListItemNode } from './CustomListItemNode'
import { CustomListNode } from './CustomListNode'
import { CustomParagraphNode } from './CustomParagraphNode'
import { CustomQuoteNode } from './CustomQuoteNode'

export const CUSTOM_NODES: Array<Klass<LexicalNode>> = [
  // Standard Lexical nodes required by plugins
  HeadingNode,
  QuoteNode,
  ListNode,
  ListItemNode,
  LinkNode,
  // Custom nodes with blockId support
  CustomParagraphNode,
  CustomHeadingNode,
  CustomListNode,
  CustomListItemNode,
  CustomQuoteNode,
  CustomDividerNode,
  CustomImageNode,
  CustomEmbedNode,
  CustomInlineEmbedNode,
  CustomEncryptedNode,
  CustomLinkNode,
]
